import { Box } from "@mui/joy";
import { useEffect, useState } from "react";
import { useCart, useSupplier } from "../../../../hooks/query";
import { useProject } from "../../../../hooks";
import { addPricingInfo } from "../utils/pricing";
import type { ProductWithPrice } from "../types";
import { ProductItem } from "./ProductItem";
import { OrderTotal } from "./OrderTotal";

export function OrderSummary() {
    const [cartItems, setCartItems] = useState<ProductWithPrice[]>([]);
    const { project } = useProject();
    const { useListByProjectId } = useCart();
    const { useListInventoryMutation } = useSupplier();
    const listCartSvc = useListByProjectId();
    const listInventorySvc = useListInventoryMutation();

    const fetchData = async () => {
        try {
            if (!project?.id) {
                return;
            }
            const response = await listCartSvc.mutateAsync({ ProjectId: project.id });
            const priceAppended = await addPricingInfo(response as any, listInventorySvc);
            setCartItems(priceAppended);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        fetchData().then();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [project?.id]);

    return (
        <Box>
            <Box display="flex" flexDirection="column">
                {cartItems.map((item) => (
                    <ProductItem key={item.Id} product={item} />
                ))}
            </Box>
            <OrderTotal items={cartItems} />
        </Box>
    );
}
